// extracted by mini-css-extract-plugin
module.exports = {"table":"table--tTX56","upload":"upload--lZNw+"};